var parent = require('../../es/symbol/iterator');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/symbol/iterator.js
// module id = 1024
// module chunks = 0